import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../_services/auth.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AppComponent } from 'src/app/app.component';
import { ToastrService } from 'src/app/_services/toastr.service';
import { HomeComponent } from '../home.component';
declare var $;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})
export class MenuComponent implements OnInit {
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: true }) table;
  @ViewChild('btnClose', { static: true }) btnClose: ElementRef;
  @ViewChild('btnModalOpen', { static: true }) btnModalOpen: ElementRef;
  menuForm: FormGroup;
  menuModel: any;
  parent = [];
  header: string;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private appComponent: AppComponent,
    private homeComponent: HomeComponent
  ) {}

  ngOnInit() {
    this.appComponent.setTitle('Menu');
  }

  SetInactive() {
    this.homeComponent.SetInactive();
  }
}
